.ui-breadcrumb {
  display: flex;
  align-items: center;
  gap: var(--lemn-space-2);
  font-size: var(--lemn-font-size-small);
  line-height: var(--lemn-line-height-small);
}

.ui-breadcrumb__separator {
  color: var(--lemn-color-disabled-text);
}

.ui-breadcrumb__item {
  padding: 0;
  background: none;
  border: 0;
  color: var(--lemn-color-text-muted);
  font: inherit;
  font-weight: var(--lemn-font-weight-medium);
  text-decoration: none;
  cursor: pointer;
}

a.ui-breadcrumb__item:hover,
button.ui-breadcrumb__item:hover {
  color: var(--lemn-color-text);
}

.ui-breadcrumb__item[data-active="true"] {
  color: var(--lemn-color-text);
  font-weight: var(--lemn-font-weight-semibold);
  cursor: default;
}

.ui-breadcrumb__item[data-static="true"] {
  cursor: default;
}
